import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import Switch from "react-switch";
import { SearchBar } from "../../../components/generic/SearchBar";
import { ModulesMeta } from "../../../constant/data";
import ModuleItem from "../../../components/forms/modules/ModuleItem";
import { IoReceipt } from "react-icons/io5";
import ModuleInstallItem from "../../../components/forms/modules/ModuleInstallItem";
import { useModulesHook } from "../../../hooks/useModulesHook";

const AllModules = () => {
  const [activeitem, setactiveitem] = useState("all");
  const navigate = useNavigate();
  const [entered, setentered] = useState("");
  const [moduleslist, setmoduleslist] = useState(ModulesMeta);
  const { allRedModues, notinstalled, allOrgModules } = useModulesHook();

  const [renderedlist, setrenderedlist] = useState<any[]>([]);
  useEffect(() => {
    setrenderedlist(allRedModues);
  }, [allRedModues]);

  const onChange = (e: string) => {
    setentered(e);
    setrenderedlist(
      allOrgModules.filter((i: any) =>
        i.moduleName.toLowerCase().includes(e.toLowerCase())
      )
    );
  };

  const Activityselect = (props: any) => (
    <div
      onClick={() => {
        props.onclick();
        setactiveitem(props.item.name);
      }}
      className={` m-2 rounded-[8px]   p-2  font-semibold ${
        props.item.name == activeitem
          ? "bg-textbg text-white"
          : " bg-faintBlue text-blueGray "
      }`}
    >
      <p className="  cursor-pointer text-xs">{props.item.name}</p>
    </div>
  );

  const [toggledevmode, settoggledevmode] = useState(false);

  return (
    <div className="w-full pr-20 flex">
      <div className={` p-6 bg-white w-full  rounded-[20px]  h-screen pb-40 overflow-y-scroll  overflow-x-hidden `}>
        <div className="  w-full  flex flex-col justify-start items-start my-4 ">
          <p className="text-textbg font-medium  flex justify-center items-center text-sm mb-2 text-[18px] bg-white">
            All Modules
          </p>
          <div className="w-full flex justify-between items-center">
            <div className="flex">
              <Activityselect
                onclick={() => {
                  setrenderedlist(allRedModues);
                }}
                item={{ name: "All" }}
              />
              <Activityselect
                onclick={() => {
                  setrenderedlist(allOrgModules);
                }}
                item={{ name: "Installed" }}
              />
              <Activityselect
                onclick={() => {
                  setrenderedlist(notinstalled);
                }}
                item={{ name: "Not Installed" }}
              />
            </div>

            <SearchBar
              placeholder="Search"
              onchange={onChange}
              value={entered}
            />
          </div>
        </div>

        <hr />
        <div className="grid grid-cols-2 gap-4">
          {renderedlist.map((item: any) => (
            //  item.category==n?
            <ModuleInstallItem
              onSelected={() => {}}
              icon={
                <IoReceipt
                  size={50}
                  className="inline p-2 ml-2 bg-blueGray text-white rounded-lg"
                />
              }
              item={item}
              selected={false}
            />
            // :""
          ))}
        </div>
      </div>
    </div>
  );
};
export { AllModules };
